// analytics.js

export function initAnalytics(isCloud) {
    const hostname = window.location.hostname

    const isJetaqsaat =
        hostname === 'jetaqsaat.ir' ||
        hostname.endsWith('.jetaqsaat.ir')

    if (!isCloud || !isJetaqsaat) {
        return
    }

    loadScript('https://www.googletagmanager.com/gtag/js?id=G-0KEW14J7V4', 'google-analytics')
    loadScript('/gtag.js', 'google-analytics-config')
    loadScript('/yektanet.js', 'yektanet')
    loadScript('https://s1.mediaad.org/serve/123946/retargeting.js', 'tapsell')
}

function loadScript(src, id) {
    if (document.getElementById(id)) {
        return
    }

    const script = document.createElement('script')

    script.id = id
    script.src = src
    script.async = true

    document.head.appendChild(script)
}